import { useState, useCallback } from 'react';

export const useExpandableCards = () => {
  const [expandedCards, setExpandedCards] = useState<Set<string>>(new Set());
  
  const toggleExpand = useCallback((id: string) => {
    setExpandedCards(prev => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  }, []);
  
  const isExpanded = useCallback((id: string) => expandedCards.has(id), [expandedCards]);
  
  return { expandedCards, toggleExpand, isExpanded };
};